import { render, staticRenderFns } from "./AccountSettingsSecurity.vue?vue&type=template&id=dd808aae&scoped=true&"
import script from "./AccountSettingsSecurity.vue?vue&type=script&lang=js&"
export * from "./AccountSettingsSecurity.vue?vue&type=script&lang=js&"
import style0 from "./AccountSettingsSecurity.vue?vue&type=style&index=0&id=dd808aae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd808aae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardText,VCol,VDivider,VForm,VImg,VRow,VTextField})
